module.exports = __webpack_public_path__ + "zztg.png?84deaab8ca2547ca8eea2ad43cddbfa4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zztg.png
// module id = 617
// module chunks = 0